var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    preserveAspectRatio: "xMinYMin",
    stroke: "currentColor",
    strokeWidth: 37
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 78,
    fill: "none"
  })));
}
export default "/_next/static/assets/public/graphics/brandCircles/0ddd13344802e160f1afef9373fa4dfc.svg";
export { SvgBrandCircle as ReactComponent };